/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  SearchAIAnswer,
  SearchAIAnswerStream,
  SearchAIQuery,
  SearchAIRecommendedQuestionStream,
  SearchAIRecommendedQuestions,
} from "./data-contracts";

/**
 * @description Ask a question to an AI across spaces that is accessible by the currently authenticated target.
 * @tags organization-ask
 * @name AskInOrganization
 * @summary Ask a question in an organization
 * @request POST:/orgs/{organizationId}/ask
 * @secure
 */

// @ts-ignore
export const askInOrganization: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /** Return query details in the result */
    details?: boolean;
  };
  RequestBody: SearchAIQuery;
  RequestHeaders: {};
  ResponseBody: {
    /** Answer from AI for a question asked on a content. */
    answer?: SearchAIAnswer;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ask",
  method: "post",
  streaming: false,
  tags: ["organization-ask"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-ask
 * @name GetRecommendedQuestionsInOrganization
 * @summary List recommended questions to ask in an organization
 * @request GET:/orgs/{organizationId}/ask/questions
 * @secure
 */

// @ts-ignore
export const getRecommendedQuestionsInOrganization: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SearchAIRecommendedQuestions;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ask/questions",
  method: "get",
  streaming: false,
  tags: ["organization-ask"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-ask
 * @name StreamRecommendedQuestionsInOrganization
 * @summary List recommended questions to ask in an organization (streamed)
 * @request GET:/orgs/{organizationId}/ask/questions/stream
 * @secure
 */

// @ts-ignore
export const streamRecommendedQuestionsInOrganization: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SearchAIRecommendedQuestionStream;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ask/questions/stream",
  method: "get",
  streaming: true,
  tags: ["organization-ask"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Ask a question to an AI across spaces that is accessible by the currently authenticated target and stream the answer as a Server-Sent Events URL.
 * @tags organization-ask
 * @name StreamAskInOrganization
 * @summary Ask a question in an organization (streamed)
 * @request GET:/orgs/{organizationId}/ask/stream
 * @secure
 */

// @ts-ignore
export const streamAskInOrganization: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    query: string;
    /** Output format for the content. */
    format?: "document" | "markdown";
    /** Return query details in the result */
    details?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SearchAIAnswerStream;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ask/stream",
  method: "get",
  streaming: true,
  tags: ["organization-ask"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
